import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { Card, CardBody, CardTitle, Col, Row } from "reactstrap";
import CustomInput from "../../Common/CustomInput/CustomInput";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useDispatch, useSelector } from "react-redux";
import { addUser, userCategoriesList } from "../../../redux/user/action";
import CreatableSelect from "react-select/creatable";
import Spinner from "../../Layouts/Spinner";
import ReactSelect from "react-select";
import { useNavigate } from "react-router-dom";
import UploadImage from "../Category/UploadImage";
import swal from "sweetalert";
import * as yup from "yup";
import MapComponent from "./UserD";
import { getAllServicesList } from "../../../redux/service/action";
import axiosInstance from "../../../redux/api";
import "../../Common/Styles/AdminEnhancements.css";

const formData = [
  { title: "First Name", name: "first_name" },
  { title: "Last Name", name: "last_name" },
  { title: "Mobile Number", name: "mobile_number" },
  { title: "Email Address", name: "email_id" },
  { title: "Password", name: "password" },
  { title: "Status", name: "status" },
  { title: "Company Name", name: "company_name" },
  { title: "Company Registration Number", name: "company_registration_number" },
  { title: "Company VAT Number", name: "company_vat_number" },
  { title: "CR Certificate (Optional)", name: "company_cr" },
  { title: "Vat Certificate (Optional)", name: "vat_certificate" },
  { title: "Profile Image (Optional)", name: "profile_image" },
  { title: "Address", name: "address" },
];

const initialValues = formData.reduce((acc, field) => {
  acc[field.name] = field.name === "status" ? 1 : "";
  return acc;
}, {
  category_id: "",
  company_services: [],
  country_code: "+966",
  latitude: "",
  longitude: "",
});

const Addadmin = ({ data }) => {
  const addadmins = (update) =>
    yup.object({
      first_name: yup
        .string()
        .required("This field is required")
        .min(2, "Enter at least two character")
        .test(
          "not-only-spaces",
          "Please enter a valid value",
          (value) => value && value.trim().length > 0
        ),
      address: yup.string().required("This Field is required"),
      last_name: yup
        .string()
        .required("This field is required")
        .test(
          "not-only-spaces",
          "Please enter a valid value",
          (value) => value && value.trim() !== ""
        ),
      mobile_number: yup
        .string()
        .min(9, "minimum number")
        .max(10, "Maximum of 10 number you can use")
        .required("mobile number is required"),
      company_name: yup
        .string()
        .required("This field is required")
        .min(2, "Enter at least two character")
        .test(
          "not-only-spaces",
          "Please enter a valid value",
          (value) => value && value.trim().length > 0
        ),
      company_registration_number: yup
        .string()
        .required("This field is required")
        .min(9, "Enter minimum 9 characters")
        .max(15, "Enter maximum 15 characters")
        .test(
          "not-only-spaces",
          "Please enter a valid value",
          (value) => value && value.trim().length > 0
        ),
      company_vat_number: yup
        .string()
        .required("This field is required")
        .min(15, "Enter minimum 15 characters")
        .max(15, "Enter maximum 15 characters")
        .test(
          "not-only-spaces",
          "Please enter a valid value",
          (value) => value && value.trim().length > 0
        ),
      status: yup
        .number()
        .oneOf(
          [1, 2, 3],
          "Status must be 1 (Active), 2 (Inactive), 3 (Blocked)"
        )
        .required("This field is required"),
      email_id: yup
        .string()
        .required("This field is required")
        .email("Enter a valid email address")
        .test(
          "optional-email-validation",
          "Enter a valid email address",
          (value) =>
            !value ||
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)
        ),
      password: yup
        .string()
        .trim()
        .required("Password is required")
        .min(8, "Password must be at least 8 characters long")
        .matches(/[a-z]/, "Password must contain at least one lowercase letter")
        .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
        .matches(/[0-9]/, "Password must contain at least one number")
        .matches(
          /[!@#$%^&*(),.?":{}|<>]/,
          "Password must contain at least one special character"
        ),
      company_cr: yup.string().nullable(),
      vat_certificate: yup.string().nullable(),
      profile_image: yup.string().nullable(),
      category_id: yup.mixed().nullable(),
      company_services: yup.array().nullable(),
    });

  const navigate = useNavigate();
  const [profileimage, setProfileimage] = useState(null);
  const [vatcertificate, setVatCartificate] = useState(null);
  const [profilelogo, setProfileLogo] = useState(null);

  const [loading, setLoading] = useState(false);
  const [update, setUpdate] = useState(data?.update);
  const dispatch = useDispatch();
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [myoptions, setOptions] = useState([]);

  const categoryList = useSelector(
    (state) => state?.reusableSlice?.categoryList
  );

  const theServices = useSelector(
    (state) => state?.reusableSlice?.getSevices.services
  );

  const proOptions = categoryList?.categories?.map((item) => ({
    value: item?.id,
    label: item?.title,
  }));
  const [params, setParams] = useState({
    type: 2,
  });

  useEffect(() => {
    dispatch(userCategoriesList(params));
    dispatch(getAllServicesList({ category_id: "" }));
  }, [dispatch, params]);

  useEffect(() => {
    theServices && setOptions(theServices ?? []);
  }, [theServices]);

  const selectedCustomer = useSelector(
    ({ category: { categorybyid } }) => categorybyid
  );

  const handleChange = (selected) => {
    setSelectedOptions(selected);
    // const categoryIds = selected.map((option) => option.value).join(",");
    formik.setFieldValue("category_id", selected.value);
    selected.value &&
      dispatch(getAllServicesList({ category_id: selected.value ?? "" }));
    setOptions([]);
    formik.setFieldValue("company_services", []);
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialValues,
    onSubmit: (value) => handleSubmit(value),
    validationSchema: addadmins(update),
  });

  const handleCountryCode = (value, data) => {
    formik.setFieldValue(
      "mobile_number",
      `${value.slice(data.dialCode.length)}`
    );
    formik.setFieldValue("country_code", `+${data.dialCode}`);
  };

  const handleKeyDown = async (event) => {
    // event.key === " " ||
    if (event.key === "Enter") {
      event.preventDefault();

      const trimmedValue = inputValue.trim();
      if (!trimmedValue) return;

      // Check if the option already exists
      const existingOption = myoptions.find(
        (opt) => opt.title.toLowerCase() === trimmedValue.toLowerCase()
      );

      let newSelectedOptions = [...formik.values.company_services];

      if (existingOption) {
        // Select existing option
        if (!newSelectedOptions.find((opt) => opt.id === existingOption.id)) {
          newSelectedOptions.push(existingOption);
        }
      } else {
        try {
          // Call API to add the new service
          const response = await axiosInstance.post(`/user/add_service`, {
            title: trimmedValue,
            category_id: formik.values.category_id,
          });

          if (response.data.status) {
            const newService = {
              id: response.data.response.id,
              title: trimmedValue,
            };
            setOptions([...myoptions, newService]);
            newSelectedOptions.push(newService);
          }
        } catch (error) {
          console.error("Error adding service:", error);
        }
      }

      formik.setFieldValue("company_services", newSelectedOptions);
      setInputValue("");
    }
  };

  const handleSubmit = async (values) => {
    if (Object.keys(formik.errors).length > 0) {
      return;
    }
    try {
      setLoading(true);

      const data = {
        ...values,
        company_services: Array.isArray(formik.values.company_services) && formik.values.company_services.length
          ? formik.values.company_services.map((item) => item.id).join(",")
          : "",
      };

      ["company_cr", "vat_certificate", "profile_image", "category_id", "company_services", "latitude", "longitude"].forEach((field) => {
        if (data[field] === "" || data[field] == null || (Array.isArray(data[field]) && !data[field].length)) {
          delete data[field];
        }
      });
      dispatch(addUser(data, setLoading, navigate));
      setUpdate(false);
    } catch (err) {
      swal({
        text: err.message || "An error occurred while submitting the form",
        icon: "error",
        button: ("Close"),
        timer: 1500,
      });
      setLoading(false);
    }
  };

  return (
    <Card>
      <CardTitle className=" py-3 mb-0 card-title1"></CardTitle>
      <CardBody className="category-wrapper">
        <h3 className="pb-2">Create Customer</h3>
        <div className="admin-highlight-box mb-3">Category and company services are no longer required here. Address can be entered manually even if Google Maps is unavailable locally.</div>
        <form onSubmit={formik.handleSubmit}>
          <Row className=" ">
            {formData.map((prop, key) => {
              if (prop.name === "mobile_number") {
                return (
                  <Col className="  " key={key} xs={4}>
                    <div className="form-group">
                      <label htmlFor={prop.name}>{(prop.title)}</label>
                      <PhoneInput
                        country={"sa"}
                        value={
                          formik?.values.country_code
                            ? `${formik.values.country_code}${formik.values.mobile_number}`
                            : ""
                        }
                        onChange={(phone, data) =>
                          handleCountryCode(phone, data)
                        }
                        onBlur={() => formik.setFieldTouched(prop.name, true)}
                      />
                    </div>
                    {formik.touched.mobile_number &&
                      formik.errors.mobile_number && (
                        <p style={{ color: "red" }}>
                          {formik.errors.mobile_number}
                        </p>
                      )}
                  </Col>
                );
              }
              if (prop.name === "status") {
                const options = [
                  { value: "1", label: ("Active") },
                  { value: "2", label: ("Inactive") },
                  { value: "3", label: ("Block") },
                ];

                return (
                  <Col className="  form-group" key={key} xs={4}>
                    <label>{(prop.title)}</label>
                    <div>
                      <ReactSelect
                        // className='form-control'
                        value={options.find(
                          (option) => option.value == formik.values?.[prop.name]
                        )}
                        placeholder={(prop.title)}
                        id={prop.name}
                        name={prop.name}
                        options={options}
                        onChange={(selectedOption) =>
                          formik.handleChange(prop.name)(selectedOption.value)
                        }
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.status && formik.errors.status && (
                        <p style={{ color: "red" }}>{formik.errors.status}</p>
                      )}
                    </div>
                  </Col>
                );
              }

              if (prop.name === "password") {
                return (
                  <Col className="  " key={key} xs={4}>
                    <div className="form-group">
                      <label>Password</label>
                      <CustomInput
                        value={formik.values?.[prop.name]}
                        placeholder={(prop.title)}
                        id={prop.name}
                        name={prop.name}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        touched={formik.touched}
                        errors={formik.errors}
                      />
                    </div>
                  </Col>
                );
              }
              if (prop.name === "email_id") {
                return (
                  <Col className="  " key={key} xs={4}>
                    <div className="form-group">
                      <label>{prop.title}</label>
                      <CustomInput
                        value={formik.values?.[prop.name]}
                        placeholder={(prop.title)}
                        id={prop.name}
                        name={prop.name}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        touched={formik.touched}
                        errors={formik.errors}
                      />
                    </div>
                  </Col>
                );
              }
              if (prop.name === "company_registration_number") {
                return (
                  <Col className="  " key={key} xs={4}>
                    <div className="form-group">
                      <label>{prop.title}</label>
                      <CustomInput
                        value={formik.values?.[prop.name]}
                        placeholder={(prop.title)}
                        id={prop.name}
                        name={prop.name}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        touched={formik.touched}
                        errors={formik.errors}
                        type="number"
                      />
                    </div>
                  </Col>
                );
              }

              if (prop.name === "company_cr") {
                return (
                  <>
                    <Col xs={12}>
                      <div className="admin-section-card admin-form-section-spacer">
                        <div className="admin-section-title">
                          <h5>Optional Company Documents</h5>
                          <span className="admin-optional-badge">Optional</span>
                        </div>
                        <p className="admin-section-note">You can save the customer without uploading any files. Add documents only when they are available.</p>
                      </div>
                    </Col>
                    <UploadImage
                      files={profileimage}
                      setFiles={setProfileimage}
                      update={update}
                      prop={prop}
                      formik={formik}
                    />
                    <div></div>
                  </>
                );
              }

              if (prop.name === "category_id") {
                return (
                  <Col className="px-2 py-2" key={key} xs={4}>
                    <label>{prop.title}</label>
                    <ReactSelect
                      // isMulti
                      value={selectedOptions}
                      onChange={handleChange}
                      options={proOptions}
                    />
                    {formik.touched[prop.name] && formik.errors[prop.name] && (
                      <div className="error">{(formik.errors[prop.name])}</div>
                    )}
                  </Col>
                );
              }
              if (prop.name == "company_services") {
                return (
                  <div className="form-group col-md-6">
                    <label>{prop.title}</label>
                    <CreatableSelect
                      isMulti
                      id="company_services"
                      name="company_services"
                      options={myoptions && myoptions}
                      getOptionLabel={(option) => option.title}
                      getOptionValue={(option) => option.id}
                      value={formik.values.company_services}
                      onChange={(selected) =>
                        formik.setFieldValue("company_services", selected || [])
                      }
                      inputValue={inputValue}
                      onInputChange={(val) => setInputValue(val)}
                      onKeyDown={handleKeyDown}
                      placeholder="Type and press enter to add"
                      menuIsOpen={false}
                      components={{
                        DropdownIndicator: () => null,
                        IndicatorSeparator: () => null
                      }}
                    />
                    <i>Press Enter to add multiple services</i>
                    {formik.touched.company_services &&
                      formik.errors.company_services && (
                        <p className="error-message">
                          {formik.errors.company_services}
                        </p>
                      )}
                  </div>
                );
              }

              if (prop.name === "address") {
                return (
                  <Col className="category-wrapper bg-white mt-2" xs={12}>
                    <div className="admin-section-title"><h5>Address Details</h5><span className="admin-optional-badge">Map optional</span></div>
                    <p className="admin-section-note">Manual address entry works even when the Google map preview is unavailable on localhost.</p>

                    <MapComponent
                      prop={prop}
                      setFieldValue={formik.setFieldValue}
                      value={formik.values[prop.name]}
                      formik={formik}
                      x={selectedCustomer.latitude}
                      y={selectedCustomer.longitude}
                    />
                  </Col>
                );
              }
              if (prop.name === "vat_certificate") {
                return (
                  <>
                    <UploadImage
                      files={vatcertificate}
                      setFiles={setVatCartificate}
                      update={update}
                      prop={prop}
                      formik={formik}
                    />
                    <div></div>
                  </>
                );
              }
              if (prop.name === "profile_image") {
                return (
                  <>
                    <UploadImage
                      files={profilelogo}
                      setFiles={setProfileLogo}
                      update={update}
                      prop={prop}
                      formik={formik}
                      type={'onlyimage'}
                    />
                    <div></div>
                  </>
                );
              }

              if (prop.name === "dob") {
                return (
                  <Col className="  " key={key} xs={4}>
                    <div className="form-group">
                      <label>{prop?.title}</label>
                      <CustomInput
                        value={formik.values?.[prop.name]}
                        placeholder={(prop.title)}
                        id={prop.name}
                        name={prop.name}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        touched={formik.touched}
                        errors={formik.errors}
                        type="date"
                      />
                      {formik.touched.dob && formik.errors.dob && (
                        <p style={{ color: "red" }}>{formik.errors.dob}</p>
                      )}
                    </div>
                  </Col>
                );
              }
              return (
                <Col className="  " key={key} xs={4}>
                  <div className="form-group">
                    <label>{prop?.title}</label>
                    <CustomInput
                      value={formik.values?.[prop.name]}
                      placeholder={(prop.title)}
                      id={prop.name}
                      name={prop.name}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      touched={formik.touched}
                      errors={formik.errors}
                    />
                    {/* {formik.touched[prop.name] && formik.errors[prop.name] && (
                      <p style={{ color: "red" }}>
                        {(formik.errors[prop.name])}
                      </p>
                    )} */}
                  </div>
                </Col>
              );
            })}
            <Col
              md={12}
              className="text-center my-3 d-flex align-items-center justify-content-between"
            >
              <button
                className="submit-btn"
                disabled={loading}
                onClick={() => navigate("/user")}
                type="submit"
              >
                Back
              </button>
              <button
                style={{ marginLeft: "10px" }}
                className="submit-btn"
                disabled={loading}
                type="submit"
              >
                {!loading ? "Submit" : <Spinner />}
              </button>
            </Col>
          </Row>
        </form>
      </CardBody>
    </Card>
  );
};

export default Addadmin;
